<template>
  <div>
    <Header />

    <h1>Rebar Data Series</h1>

    <table id="data-table">
      <colgroup>
        <col id="column-category">
        <col id="column-name">
        <col id="column-description">
      </colgroup>
      
      <tr>
        <th>Category</th>
        <th>Data Name</th>
        <th>Data Description</th>
      </tr>

      <tbody v-if="loaded">
        <router-link tag="tr" :to="`/data/${series['ID']}`" v-for="series in dataSeriesList" :key="series['ID']">
          <td>
            {{ series['Category'] | splitCategory }}
          </td>
          <td>
            <span class="series-name-text">{{ series['Label'] }}</span>
              <br/>
            <span class="series-id-text">#{{ series['ID'] }}</span>
          </td>
          <td class="series-description">
            {{ series['Description'] | truncate(60) }}
          </td>
        </router-link>
      </tbody>
    </table>

    <br />
    <hr />

    <EmailCollection />

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import EmailCollection from '@/components/layout/EmailCollection';

const axios = require('axios');
const _ = require('lodash');

export default {
  name: 'DataListing',
  components: {
    Header,
    Footer,
    EmailCollection
  },
  data() {
    return {
      loaded: false,
      dataSeriesList: []
    }
  },
  filters: {
    truncate: function(text, maxLength) {
      if (text.length > maxLength) {
        return text.slice(0,maxLength) + '...';
      } else {
        return text;
      }
    },
    splitCategory: function(text) {
      return text.split('#').join(' / ');
    }
  },
  created() {
    this.loadRemoteData();
  },
  methods: {
    loadRemoteData() {
      axios.get(`${this.$api}/data`)
        .then((response) => {
          let responseData = (response.data || {});

          this.dataSeriesList = responseData;
          this.loaded = true;
        })
        .catch(() => console.log("Error loading data"));
    }
  }
}
</script>

<style scoped>
#data-table {
  margin-left: auto;
  margin-right: auto;
  width: 75%;
}

#data-table th {
  background-color: #0666b4;
  color: #ffffff;
  padding: 0 45px;
}
#data-table td {
  padding: 0 5px;
}
#data-table tr:hover, #data-table tr:hover {
  background-color:#edf3f7;
}

#column-description {
  width: 30%;
}

.series-id-text {
  color: gray;
  font-size: .8em;
}
.series-description {
  font-size: .8em;
}

@media only screen and (max-width: 800px) {
  th:nth-child(3), td:nth-child(3) {
    display:none;
  }
}
</style>
